<form [formGroup]="form" (ngSubmit)="reAppointment()">
    <h1 mat-dialog-title>Recitación del turno</h1>
    <div mat-dialog-content>
        <mat-label>¿Está seguro de marcar el paciente para recitación? En caso afirmativo, indicar acercarse a Recepción para programar turno</mat-label>
        <mat-form-field class="full-control">
            <input type="number" matInput placeholder="Duración recitación (minutos)" formControlName="ReappointmentDuration">
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
            <button *ngIf="!loading" mat-button type="submit">Aceptar</button>
            <button *ngIf="!loading" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>
